import { render, staticRenderFns } from "./CardListModules.vue?vue&type=template&id=ffcfde1c&scoped=true"
import script from "./CardListModules.vue?vue&type=script&lang=js"
export * from "./CardListModules.vue?vue&type=script&lang=js"
import style0 from "./CardListModules.vue?vue&type=style&index=0&id=ffcfde1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcfde1c",
  null
  
)

export default component.exports